










































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import ImpersonateMenu from '@/components/ImpersonateMenu'

settings =
  name: 'Navbar'

  vue:
    store: [ "member" ]
    components: {
      LoadingIndicator,
      ImpersonateMenu,
    }

    computed:
      isOffersRoute: -> @$route.name.includes('Offer')
      isCampaignsRoute: -> @$route.name.includes('Campaign')
      isEventFeedRoute: -> !@isCampaignsRoute and @$route.name.includes('EventFeed')
      isScheduleRoute: -> @$route.name.includes('EventSchedule')

    methods:
      handleDropdownActionClicked: (command) ->
        switch command
          when 'account' then @$router.push({ name : 'MeShowPage' })
          when 'logout' then @logout()

export default VueOptions.vue settings
